const VETERAN_NUMBER_PATTERN = /^[A-Za-z0-9]{1,9}$/;

export function isValidVeteranNumber(value) {
  return VETERAN_NUMBER_PATTERN.test(value);
}
